import ChatbotBase from "./ChatbotBase";

function ShopfloorChatbot({ toggleChatbot, openChatbot, username, groupName }) {
    return <ChatbotBase toggleChatbot={toggleChatbot} openChatbot={openChatbot} username={username} groupName={groupName}/>;
}

export default ShopfloorChatbot;
